/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const featureFlagListDataSchema = z.object({
	features: z.array(
		z.object({
			feature: z.union([
				z.literal('global-ai-chat'),
				z.literal('enlarged-feed-images'),
				z.literal('talent-pool-ai-summary'),
				z.literal('asset-hub-signed-uploads'),
				z.literal('whatsapp-ai-agent'),
				z.literal('whatsapp-direct-send'),
				z.literal('whatsapp-ai-continuation'),
				z.literal('microsoft-365-calendar'),
			]),
			enabled: z.boolean(),
		}),
	),
})

export type FeatureFlagListDataSchema = z.infer<typeof featureFlagListDataSchema>
